import React, { forwardRef } from "react";
import Box, { BoxProps } from "./Box";

interface IFlex {
  /**
   * Shorthand for Styled-System `alignItems` prop
   */
  align?: BoxProps["alignItems"];
  /**
   * Shorthand for Styled-System `justifyContent` prop
   */
  justify?: BoxProps["justifyContent"];
  /**
   * Shorthand for Styled-System `flexWrap` prop
   */
  wrap?: BoxProps["flexWrap"];
  /**
   * Shorthand for Styled-System `flexDirection` prop
   */
  direction?: BoxProps["flexDirection"];
}

export type FlexProps = BoxProps & IFlex;

const Flex = forwardRef<any, FlexProps>(({ align, justify, wrap, direction, ...rest }, ref) => {
  return (
    <Box
      ref={ref}
      display="flex"
      flexDirection={direction}
      alignItems={align}
      justifyContent={justify}
      flexWrap={wrap}
      {...rest}
    />
  );
});

Flex.displayName = "Flex";

export default Flex;
